import { Colors } from "@/enums/Colors";
import { Box, Typography, styled } from "@mui/material";
import PlanetsSvg from "../../../assets/images/planets.svg";

interface Props {
  title: string;
  type: string;
}

export const SharedFinancialReportGenerationComm = (props: Props) => {
  return (
    <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} sx={{ padding: "2rem 0" }} gap={1}>
      <img src={PlanetsSvg.src} style={{ height: "30vh" }} />
      <Title>Your {props.title} is being generated.</Title>
      <SubtTitle>You'll be notified via email once the {props.type} is ready.</SubtTitle>
      {/*
            <CommonButton 
                purpleBorderVariant
                startIcon={<img src={Mail.src} />}
                sx={{marginTop: "1rem", borderRadius: ".5rem", padding: ".75rem 1.875rem"}}
            >
                <ButtonText>We'll email you when ready</ButtonText>
            </CommonButton>
        */}
    </Box>
  );
};
const Title = styled(Typography)(() => ({
  fontSize: ".875rem",
  fontWeight: "600",
  lineHeight: "1.25rem",
  color: Colors.BLACK_2,
}));

const SubtTitle = styled(Typography)(() => ({
  fontSize: "0.75rem",
  fontWeight: "400",
  lineHeight: "1.125rem",
  color: Colors.LIGHT_GRAY_8A8E93,
}));

const ButtonText = styled(Typography)(() => ({
  fontSize: "0.875rem",
  fontWeight: "600",
  lineHeight: "1.1.25",
}));
